import { IDTO, IResponseDto } from 'src/entities/common';
import { IQuestion } from '../../entities/question';
import fetcher from '../fetcher';
import { IServiceDetails, IServiceIntervalRequest, IServiceArriveTimeRequest, fillPayableField, fillPayableFields } from './../../entities/service';
import { IDateInterval, ICalendarIntervals } from 'src/entities/calendar';
import { handleError } from './errorHandler';

export const getServices = (onlyWithVisibleCalendars?: boolean): Promise<IServiceDetails[]> => {
    const params = onlyWithVisibleCalendars ?
        '?' + new URLSearchParams({
            onlyWithVisibleCalendars: '' + onlyWithVisibleCalendars,
        }).toString() : ''

    return fetcher.get<IDTO<IServiceDetails[]>>(`/Services/WithDetails${params}`)
        .then(respJson => fillPayableFields(respJson.Data) || [], () => []);
};

export const getServicesByCalendar = (id: number): Promise<IServiceDetails[]> => {
    return fetcher.get<IDTO<IServiceDetails[]>>(`/Calendars/${id}/Services/WithDetails`)
        .then(respJson => fillPayableFields(respJson.Data) || [], () => []);
};

export const getServiceById = (id: number): Promise<IServiceDetails> => {
    return fetcher.get<IDTO<IServiceDetails>>(`/Services/${id}`)
        .then((respJson) => fillPayableField(respJson.Data), (() => Promise.reject(null)))
};

export const getCustomParams = (id: number): Promise<IQuestion[]> => {
    return fetcher.get<IDTO<IQuestion[]>>(`/Services/${id}/CustomParams`)
        .then((respJson) => respJson.Data || [], () => []);
}

export const getServiceFirstFreeSlot = (serviceId: number): Promise<string> => {
    const params = serviceId ?
        '?' + new URLSearchParams({
            ServiceId: '' + serviceId,
        }).toString() : ''
    return fetcher.get<IDTO<string>>(`/Services/${serviceId}/FirstFreeSlot${params}`)
        .then((respJson) => respJson.Data || '');
};

export const getServiceMaxWeeksForward = (serviceId: number): Promise<number> => {
    return fetcher.get<IDTO<number>>(`/Services/${serviceId}/WeeksForwardMax`)
        .then((respJson) => respJson.Data || 1);
};

export const getServiceDaysWithFreeIntervals =
    (request: IServiceIntervalRequest): Promise<string[] | null> => {
        return fetcher.post<IDTO<string[]>>(`/Services/${request.serviceId}/DaysWithFreeIntervals`, request)
            .then(response => {
                return response.Data
            }, (errorDto: IResponseDto) => {
                return Promise.reject(handleError(errorDto));
            });
    };

export const getServiceFreeIntervals =
    (request: IServiceIntervalRequest): Promise<IDateInterval[] | null> => {
        request.endDate = request.endDate || request.startDate;

        return fetcher.post<IDTO<ICalendarIntervals>>(`/Services/${request.serviceId}/FreeIntervals`, request)
            .then(response => {
                return response.Data.Intervals
            }, (errorDto: IResponseDto) => {
                return Promise.reject(handleError(errorDto));
            });
    }

export const getServiceArriveTimes =
    (request: IServiceArriveTimeRequest): Promise<string[]> => {
        const params =
            '?' + new URLSearchParams({
                Date: '' + request.startDate,
            }).toString();

        return fetcher.get<IDTO<string[]>>(`/Services/${request.serviceId}/ArrivalTimes${params}`)
            .then(response => {
                return response.Data
            }, (errorDto: IResponseDto) => {
                return Promise.reject(handleError(errorDto));
            });
    }